import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_BOOKING_LENGTH, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemBookingLengthMaybe = props => {
  const { lineItems, intl } = props;

  const bookingLengthLineItem = lineItems.find(
    item => item.code === LINE_ITEM_BOOKING_LENGTH && !item.reversal
  );

  return bookingLengthLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.bookingLength" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, bookingLengthLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemBookingLengthMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBookingLengthMaybe;
